export const fr_FR = {
  file: {
    INVALID_TYPE: "Message mauvais type",
    INVALID_EXTENSION: "Message mauvaise extension",
    INVALID_MAX_TOTAL_SIZE: "Message taille totale dépassée",
    success: "Fichier sélectionné"
  }
  // notEmpty: {
  //   default: "Ce champ est obligatoire"
  // }
};
